<template>
<div>
     <template>
          <v-card :width="widthP - 270" class="ma-4">
               <v-row>
                    <v-col cols="12" :lg="((child.id==2 && idPage != 5 ) ||   idPage == 6 || idPage == 4|| idPage == 3|| idPage == 7) ? 12 : 8" :md="((child.id==2 && idPage != 5 )||   idPage == 6 || idPage == 4|| idPage == 3|| idPage == 7)  ? 12 : 8" sm="12">
                         <v-card-title v-if="idPage != 7">
                              {{ getName(child.id) + " :   " }}
                              <v-spacer></v-spacer>
                              <div class="my-2 mx-8">
                                   <v-tooltip v-if="idPage != 4" bottom>
                                        <template v-slot:activator="{ on }">
                                             <v-btn v-on="on" :loading="loading4" :disabled="loading4" color="info  lighten-1" @click="sendData(idPage)">
                                                  <v-icon light>mdi-content-save-alert</v-icon>
                                                  <template v-slot:loader>
                                                       <span class="custom-loader">
                                                            <v-icon light>mdi-cached</v-icon>
                                                       </span>
                                                  </template>
                                             </v-btn>
                                        </template>
                                        <span>{{ $t('update') }}</span>
                                   </v-tooltip>

                                   <v-tooltip v-if="idPage == 4" bottom>
                                        <template v-slot:activator="{ on }">
                                             <v-btn class="mx-4" v-on="on" dark color="red  lighten-1" @click="deleteAll()">
                                                  <v-icon light>mdi-delete-sweep-outline</v-icon>
                                             </v-btn>
                                        </template>
                                        <span>{{ $t('deleteAll') }}</span>
                                   </v-tooltip>

                                   <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                             <v-btn @click="goToDefault" class="mx-4" v-on="on" color="warning lighten-1" dark>
                                                  <v-icon light>mdi-keyboard-return</v-icon>
                                             </v-btn>
                                        </template>
                                        <span>{{ $t('defaultVal') }}</span>
                                   </v-tooltip>

                                   <template v-if="idPage == 4">
                                        <v-tooltip bottom>
                                             <template v-slot:activator="{ on }">
                                                  <v-btn class="mx-4" @click="openDialog('',false)" v-on="on" color="green lighten-1" dark>
                                                       <v-icon light>mdi-plus</v-icon>
                                                  </v-btn>
                                             </template>
                                             <span>{{ $t('addImg') }}</span>
                                        </v-tooltip>
                                   </template>

                              </div>
                         </v-card-title>
                         <v-card-title class="text-center" v-else>
                              <h2 style="color:#777">{{ $t('news') }}</h2>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                   <template v-slot:activator="{ on }">
                                        <v-btn class="mx-3" v-on="on" dark color="orange lighten-1" @click="clear()">
                                             <v-icon light>mdi-notification-clear-all</v-icon>
                                        </v-btn>
                                   </template>
                                   <span>{{ $t('clear') }}</span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                   <template v-slot:activator="{ on }">
                                        <v-btn class="mx-3" v-on="on" :disabled="loading" color="info lighten-1" @click="saveNews()">
                                             <v-icon light>mdi-content-save-alert</v-icon>
                                             <template v-slot:loader>
                                                  <span class="custom-loader">
                                                       <v-icon light>mdi-cached</v-icon>
                                                  </span>
                                             </template>
                                        </v-btn>
                                   </template>
                                   <span>{{ $t('update') }}</span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                   <template v-slot:activator="{ on }">
                                        <v-btn class="mx-3" v-on="on" dark color="red lighten-1" @click="removeItem">
                                             <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                   </template>
                                   <span>{{ $t('delete') }}</span>
                              </v-tooltip>
                         </v-card-title>
                         <v-card-text>
                              <template v-if="idPage == 7">
                                   <v-row>
                                        <v-col cols="12" lg="8" md="8" sm="12">
                                             <v-row>
                                                  <v-col cols="5">
                                                       <input type="file" ref="imgs" hidden @change="selectImgNew">
                                                       <v-card @click="$refs.imgs.click()" max-height="100%" max-width="100%" class="">
                                                            <v-avatar tile class="profil" height="100%" width="100%">
                                                                 <v-img aspect-ratio="1" v-if="forUpdat" contain :src="'news/' + (news.img ? news.img : 'addImg.png' ) | URL" max-width="100%"></v-img>
                                                                 <v-img aspect-ratio="1" v-else contain :src="img" max-width="100%"></v-img>
                                                            </v-avatar>
                                                       </v-card>
                                                  </v-col>
                                                  <v-col cols="7">
                                                       <v-col cols="12">
                                                            <v-textarea rows="3" :label="$t('title')" v-model="news.title" clearable dense outlined hide-details></v-textarea>
                                                       </v-col>
                                                       <v-col cols="12">
                                                            <v-textarea rows="3" :label="$t('titleAr')" v-model="news.titleAr" clearable dense outlined hide-details></v-textarea>
                                                       </v-col>
                                                  </v-col>
                                                  <v-col cols="6">
                                                       <v-textarea rows="3" :label="$t('text1')" v-model="news.text1" clearable dense outlined hide-details></v-textarea>
                                                  </v-col>
                                                  <v-col cols="6">
                                                       <v-textarea rows="3" :label="$t('text1Ar')" v-model="news.text1Ar" clearable dense outlined hide-details></v-textarea>
                                                  </v-col>
                                                  <v-col cols="6">
                                                       <v-textarea rows="3" :label="$t('text2')" v-model="news.text2" clearable dense outlined hide-details></v-textarea>
                                                  </v-col>
                                                  <v-col cols="6">
                                                       <v-textarea rows="3" :label="$t('text2Ar')" v-model="news.text2Ar" clearable dense outlined hide-details></v-textarea>
                                                  </v-col>
                                                  <v-col cols="6">
                                                       <v-textarea rows="3" :label="$t('text3')" v-model="news.text3" clearable dense outlined hide-details></v-textarea>
                                                  </v-col>
                                                  <v-col cols="6">
                                                       <v-textarea rows="3" :label="$t('text3Ar')" v-model="news.text3Ar" clearable dense outlined hide-details></v-textarea>
                                                  </v-col>
                                                  <v-col cols="6">
                                                       <v-textarea rows="3" :label="$t('text4')" v-model="news.text4" clearable dense outlined hide-details></v-textarea>
                                                  </v-col>
                                                  <v-col cols="6">
                                                       <v-textarea rows="3" :label="$t('text4Ar')" v-model="news.text4Ar" clearable dense outlined hide-details></v-textarea>
                                                  </v-col>
                                             </v-row>
                                        </v-col>
                                        <v-col cols="12" lg="4" md="4" sm="12">

                                             <v-card class="mx-auto" max-width="100%" tile>
                                                  <v-list flat>
                                                       <v-subheader>
                                                            <v-text-field @keyup="realTimeSearch()" v-model="keyword" rows="2" :label="$t('search')" clearable dense outlined hide-details></v-text-field>
                                                       </v-subheader>
                                                       <v-list-item-group color="primary">
                                                            <v-list-item v-for="(item, i) in allNews" :key="i">
                                                                 <v-list-item-icon>
                                                                      <!-- <v-img aspect-ratio="1.5" contain :src="'news/' + item.img  | URL" max-width="100%"></v-img> -->
                                                                      <h6>{{ item.created_at |  moment}}</h6>
                                                                 </v-list-item-icon>

                                                                 <v-list-item-content @click="remplirForm(item)" v-text="localLang == 'fr' ? item.title : item.titleAr">
                                                                      <v-list-item-title>
                                                                      </v-list-item-title>
                                                                 </v-list-item-content>

                                                            </v-list-item>
                                                       </v-list-item-group>
                                                  </v-list>
                                             </v-card>
                                        </v-col>
                                   </v-row>
                              </template>
                              <template v-if="idPage != 4">
                                   <v-row v-for="(e,index) in data.form" :key="index">
                                        <template v-if="e.nameFr != '/' && child.id == e.idSection">
                                             <v-col cols="12" lg="6" md="6">
                                                  <v-textarea rows="5" v-model="e.nameFr" clearable dense outlined hide-details></v-textarea>
                                             </v-col>
                                             <v-col cols="12" lg="6" md="6">
                                                  <v-textarea rows="5" v-model="e.nameAr" clearable dense outlined hide-details></v-textarea>
                                             </v-col>
                                        </template>
                                   </v-row>
                              </template>
                              <template v-else>
                                   <v-row v-for="(e,index) in data.form" :key="index">
                                        <template v-if="e.elementName == 'P4S1HeadTitle' || e.elementName == 'P4S1Title' ">
                                             <v-col cols="12" class="pa-1" lg="6" md="6">
                                                  <v-textarea rows="1" v-model="e.nameFr" clearable dense outlined hide-details></v-textarea>
                                             </v-col>
                                             <v-col cols="12" class="pa-1" lg="6" md="6">
                                                  <v-textarea rows="1" v-model="e.nameAr" clearable dense outlined hide-details></v-textarea>
                                             </v-col>
                                        </template>
                                   </v-row>
                                   <v-row>
                                        <template class="mt-8" v-for="(e,index) in data.form ">
                                             <v-col :key="index" v-if=" e.elementName == 'elements'" cols="12" lg="3" md="3" sm="4">
                                                  <v-img aspect-ratio="1.54" contain max-width="100%" :src="'galeri/'+ e.img | URL">
                                                       <v-btn text color="red" @click="deleteImg(e)">
                                                            <v-icon>mdi-delete</v-icon>
                                                       </v-btn><br>
                                                       <v-btn text color="green" @click="openDialog(e,true)">
                                                            <v-icon>mdi-update</v-icon>
                                                       </v-btn>
                                                  </v-img>
                                             </v-col>
                                        </template>

                                   </v-row>

                              </template>
                         </v-card-text>
                    </v-col>
                    <v-col cols="12" lg="4" md="4" sm="12">
                         <v-row style="margin-top:85px" v-if="idPage == 1">
                              <v-col cols="12" v-if="child.id == 3 ">
                                   <input type="file" ref="img4" hidden @change="selectImg(1,'P1S3Img1')">
                                   <v-card @click="$refs.img4.click()" max-height="100%" max-width="100%" class="">
                                        <v-avatar tile class="profil" height="100%" width="100%">
                                             <v-img aspect-ratio="1.54" contain v-if="items.P1S3Img1 != ''" :src="items.P1S3Img1" max-height="100%" max-width="100%"></v-img>
                                             <v-img aspect-ratio="1.54" contain v-else :src="'home/'+ (checkDefault2( 'P1S3Img1',false) ? checkDefault2( 'P1S3Img1',false).img : '')  | URL" max-height="100%" max-width="100%"></v-img>
                                        </v-avatar>
                                   </v-card>
                              </v-col>
                              <template v-else-if="child.id == 1">
                                   <v-col cols="12">
                                        <input type="file" ref="img1" hidden @change="selectImg(2,'P1S1Img1')">
                                        <v-card @click="$refs.img1.click()" max-height="100%" max-width="100%" class="">
                                             <v-avatar tile class="profil" height="100%" width="100%">
                                                  <v-img v-if="items.P1S1Img1 != ''" :src="items.P1S1Img1" max-height="100%" max-width="100%"></v-img>
                                                  <v-img v-else :src="'home/'+ (checkDefault2( 'P1S1Img1' ,false) ? checkDefault2( 'P1S1Img1' ,false).img : '') | URL" max-height="100%" max-width="100%"></v-img>
                                             </v-avatar>
                                        </v-card>
                                   </v-col>
                                   <v-col cols="6">
                                        <input type="file" ref="img2" hidden @change="selectImg(3,'P1S1Img2')">
                                        <v-card @click="$refs.img2.click()" max-height="100%" max-width="100%" class="">
                                             <v-avatar tile class="profil" height="100%" width="100%">
                                                  <v-img v-if="items.P1S1Img2 != ''" :src="items.P1S1Img2" max-height="100%" max-width="100%"></v-img>
                                                  <v-img v-else :src="'home/'+ (checkDefault2('P1S1Img2', false) ? checkDefault2('P1S1Img2', false).img : '') | URL" max-height="100%" max-width="100%"></v-img>
                                             </v-avatar>
                                        </v-card>
                                   </v-col>
                                   <v-col cols="6">
                                        <input type="file" ref="img3" hidden @change="selectImg(4,'P1S1Img3')">
                                        <v-card @click="$refs.img3.click()" max-height="100%" max-width="100%" class="">
                                             <v-avatar tile class="profil" height="100%" width="100%">
                                                  <v-img v-if="items.P1S1Img3 != ''" :src="items.P1S1Img3" max-height="100%" max-width="100%"></v-img>
                                                  <v-img v-else :src="'home/'+ (checkDefault2('P1S1Img3',false) ? checkDefault2('P1S1Img3',false).img : '') | URL" max-height="100%" max-width="100%"></v-img>
                                             </v-avatar>
                                        </v-card>
                                   </v-col>
                              </template>
                         </v-row>
                         <v-row v-if="idPage == 2">
                              <v-col cols="12" style="margin-top:85px">
                                   <input type="file" ref="img5" hidden @change="selectImg(5,'P2S1Img1')">
                                   <v-card @click="$refs.img5.click()" max-height="100%" max-width="100%" class="">
                                        <v-avatar tile class="profil" height="100%" width="100%">
                                             <v-img v-if="items.P2S1Img1 != ''" :src="items.P2S1Img1" max-height="100%" max-width="100%"></v-img>
                                             <v-img v-else :src="'service/'+ (checkDefault2( 'P2S1Img1',false) ?  checkDefault2( 'P2S1Img1',false).img : '') | URL" max-height="100%" max-width="100%"></v-img>
                                        </v-avatar>
                                   </v-card>
                              </v-col>
                              <v-col cols="12" style="margin-top:100px">
                                   <input type="file" ref="img6" hidden @change="selectImg(6,'P2S1Img2')">
                                   <v-card @click="$refs.img6.click()" max-height="100%" max-width="100%" class="">
                                        <v-avatar tile class="profil" height="100%" width="100%">
                                             <v-img v-if="items.P2S1Img2 != ''" :src="items.P2S1Img2" max-height="100%" max-width="100%"></v-img>
                                             <v-img v-else :src="'service/'+ (checkDefault2( 'P2S1Img2',false) ?  checkDefault2( 'P2S1Img2',false).img : '') | URL" max-height="100%" max-width="100%"></v-img>
                                        </v-avatar>
                                   </v-card>
                              </v-col>
                              <v-col cols="12" style="margin-top:100px">
                                   <input type="file" ref="img7" hidden @change="selectImg(7,'P2S1Img3')">
                                   <v-card @click="$refs.img7.click()" max-height="100%" max-width="100%" class="">
                                        <v-avatar tile class="profil" height="100%" width="100%">
                                             <v-img v-if="items.P2S1Img3 != ''" :src="items.P2S1Img3" max-height="100%" max-width="100%"></v-img>
                                             <v-img v-else :src="'service/'+ (checkDefault2( 'P2S1Img3',false) ?  checkDefault2( 'P2S1Img3',false).img : '') | URL" max-height="100%" max-width="100%"></v-img>
                                        </v-avatar>
                                   </v-card>
                              </v-col>
                              <v-col cols="12" style="margin-top:100px">
                                   <input type="file" ref="img8" hidden @change="selectImg(8,'P2S1Img4')">
                                   <v-card @click="$refs.img8.click()" max-height="100%" max-width="100%" class="">
                                        <v-avatar tile class="profil" height="100%" width="100%">
                                             <v-img v-if="items.P2S1Img4 != ''" :src="items.P2S1Img4" max-height="100%" max-width="100%"></v-img>
                                             <v-img v-else :src="'service/'+ (checkDefault2( 'P2S1Img4',false) ?  checkDefault2( 'P2S1Img4',false).img : '') | URL" max-height="100%" max-width="100%"></v-img>
                                        </v-avatar>
                                   </v-card>
                              </v-col>
                              <v-col cols="12" style="margin-top:100px">
                                   <input type="file" ref="img9" hidden @change="selectImg(9,'P2S1Img5')">
                                   <v-card @click="$refs.img9.click()" max-height="100%" max-width="100%" class="">
                                        <v-avatar tile class="profil" height="100%" width="100%">
                                             <v-img v-if="items.P2S1Img5 != ''" :src="items.P2S1Img5" max-height="100%" max-width="100%"></v-img>
                                             <v-img v-else :src="'service/'+ (checkDefault2( 'P2S1Img5',false) ?  checkDefault2( 'P2S1Img5',false).img : '') | URL" max-height="100%" max-width="100%"></v-img>
                                        </v-avatar>
                                   </v-card>
                              </v-col>
                         </v-row>
                         <v-row v-if="idPage == 5">
                              <v-col v-if="child.id == 1" cols="12" style="margin-top:100px">
                                   <input type="file" ref="img10" hidden @change="selectImg(10,'P5S1Img1')">
                                   <v-card @click="$refs.img10.click()" max-height="100%" max-width="100%">
                                        <v-avatar tile class="profil" height="100%" width="100%">
                                             <v-img v-if="items.P5S1Img1 !=''" :src="items.P5S1Img1" max-height="100%" max-width="100%"></v-img>
                                             <v-img v-else :src="'espace_patient/' + (checkDefault2('P5S1Img1', false) ? checkDefault2('P5S1Img1', false).img : '') | URL" max-height="100%" max-width="100%"></v-img>
                                        </v-avatar>
                                   </v-card>
                              </v-col>
                              <v-col v-if="child.id == 2" cols="12" style="margin-top:100px">
                                   <input type="file" ref="img11" hidden @change="selectImg(11,'P5S2Img1')">
                                   <v-card @click="$refs.img11.click()" max-height="100%" max-width="100%">
                                        <v-avatar tile class="profil" height="100%" width="100%">
                                             <v-img v-if="items.P5S2Img1 !=''" :src="items.P5S2Img1" max-height="100%" max-width="100%"></v-img>
                                             <v-img v-else :src="'espace_patient/' + (checkDefault2('P5S2Img1', false) ? checkDefault2('P5S2Img1', false).img : '') | URL" max-height="100%" max-width="100%"></v-img>
                                        </v-avatar>
                                   </v-card>
                              </v-col>
                              <v-col v-if="child.id == 3" cols="12" style="margin-top:100px">
                                   <input type="file" ref="img12" hidden @change="selectImg(12,'P5S3Img1')">
                                   <v-card @click="$refs.img12.click()" max-height="100%" max-width="100%">
                                        <v-avatar tile class="profil" height="100%" width="100%">
                                             <v-img v-if="items.P5S3Img1 !=''" :src="items.P5S3Img1" max-height="100%" max-width="100%"></v-img>
                                             <v-img v-else :src="'espace_patient/' + (checkDefault2('P5S3Img1', false) ? checkDefault2('P5S3Img1', false).img : '') | URL" max-height="100%" max-width="100%"></v-img>
                                        </v-avatar>
                                   </v-card>
                              </v-col>
                              <v-col v-if="child.id == 4" cols="12" style="margin-top:100px">
                                   <input type="file" ref="img13" hidden @change="selectImg(13,'P5S4Img1')">
                                   <v-card @click="$refs.img13.click()" max-height="100%" max-width="100%">
                                        <v-avatar tile class="profil" height="100%" width="100%">
                                             <v-img v-if="items.P5S4Img1 !=''" :src="items.P5S4Img1" max-height="100%" max-width="100%"></v-img>
                                             <v-img v-else :src="'espace_patient/' + (checkDefault2('P5S4Img1', false) ? checkDefault2('P5S4Img1', false) : '') | URL" max-height="100%" max-width="100%"></v-img>
                                        </v-avatar>
                                   </v-card>
                              </v-col>
                         </v-row>
                    </v-col>
               </v-row>
          </v-card>
     </template>

     <v-dialog v-model="dialog" persistent max-width="700">
          <v-card>
               <v-card-title class="headline">
                    {{ showForUpdate ? $t('updateImg') : $t('addImg') }}
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" color="error" outlined icon @click="close()" class="mt-1 mr-2">
                                   <v-icon>mdi-close</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('close') }}</span>
                    </v-tooltip>
               </v-card-title>
               <v-card-text>
                    <v-row style="">
                         <v-col cols="4">
                              <input type="file" multiple ref="img4" hidden @change="selectImgs">

                              <v-card @click="$refs.img4.click()" max-height="100%" max-width="100%" class="">
                                   <v-avatar tile class="profil" height="100%" width="100%">
                                        <v-img v-if="(P4S1Img1 != '' && !hasImg)" :src="P4S1Img1" max-height="100%" max-width="100%"></v-img>
                                        <v-img v-else-if="hasImg" :src="'galeri/' + P4S1Img1 | URL" max-height="100%" max-width="100%"></v-img>
                                        <v-img v-else :src="require('@/assets/addImg.png')" max-height="100%" max-width="100%"></v-img>
                                   </v-avatar>
                              </v-card>
                         </v-col>
                         <v-col cols="4">
                              <v-textarea rows="5" counter v-model="form.nameFr" :rules="localLang == 'fr' ? rules : rules1 " :label="$t('descriptionFr')" clearable outlined></v-textarea>
                         </v-col>
                         <v-col cols="4">
                              <v-textarea rows="5" counter v-model="form.nameAr" :rules="localLang == 'fr' ? rules : rules1 " :label="$t('descriptionAr')" clearable outlined></v-textarea>
                         </v-col>
                    </v-row>
               </v-card-text>
               <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" :disabled="isLoaded" text @click="saveImg">{{ showForUpdate ? $t('update') :  $t('save') }}</v-btn>
               </v-card-actions>
          </v-card>
     </v-dialog>
</div>
</template>

<script>
export default {
     components: {},
     props: {
          widthP: Number
     },
     data: () => ({
          isLoaded: false,
          keyword: '',
          forUpdat: true,
          rules: [v => v.length <= 288 || '288 caractères maximum'],
          rules1: [v => v.length <= 288 || '288 حرفًا كحد أقصى'],
          showForUpdate: false,
          hasImg: false,
          value: 'sdsdsdsd',
          dialog: false,
          // registryDocFile: [],
          testForm: [],
          images: [],
          data: {
               idUser: "",
               domainName: '',
               idPage: 1,
               form: {},
          },
          news: [],
          loader: null,
          loading4: false,
          loading: false,
          idPage: 1,
          form: {},
          child: {
               id: 1,
          },
          idNews: 1,
          P4S1Img1: '',
          items: {
               P1S1Img1: '',
               P1S1Img2: '',
               P1S1Img3: '',
               P1S3Img1: '',

               P2S1Img1: '',
               P2S1Img2: '',
               P2S1Img3: '',
               P2S1Img4: '',
               P2S1Img5: '',

               P5S1Img1: '',
               P5S2Img1: '',
               P5S3Img1: '',
               P5S4Img1: '',
          },
          P1S3Img5: '',
     }),
     watch: {
          loader() {
               const l = this.loader
               this[l] = !this[l]
               setTimeout(() => (this[l] = false), 3000)
               this.loader = null
          },
     },
     methods: {

          goToDefault() {
               var commit = 'getDataWebsite'
               var url = 'getDataWebsite/goToDefault'

               this.$Delete({
                    domainName: document.location.origin
               }, url, commit)
               this.$store.dispatch('getDataWebsite')
               this.init()
          },
          removeItem() {
               var commit = 'getNews'
               var url = 'getNews/removeItem'

               this.$Delete({
                    id: JSON.stringify(this.idNews)
               }, url, commit)
               this.$store.dispatch('getNews')
               this.init()
          },
          remplirForm(data) {
               this.forUpdat = true
               this.idNews = data.id
               this.news = data
          },
          saveNews() {
               this.loading = true
               var commit = 'getNews'
               var url = 'getNews/saveNews'

               this.news.domainName = document.location.origin

               this.$Register({
                    data: JSON.stringify(this.news),
                    file: this.news.img
               }, url, commit).then((data) => {
                    this.init()
                    this.loading = false
               }, () => {
                    this.loading = false
               })

          },
          realTimeSearch() {
               this.$store.dispatch('searchPost', {
                    data: JSON.stringify(this.keyword)
               })
          },

          openDialog(item, state) {
               this.init()
               if (state) {
                    this.showForUpdate = true
                    this.form = item
                    this.hasImg = true
                    this.P4S1Img1 = item.img
                    this.dialog = true
               } else {
                    this.showForUpdate = false
                    this.hasImg = false
                    this.dialog = true
               }
          },
          deleteAll() {},
          init() {
               this.P4S1Img1 = ''
               this.form = {
                    P4S1Img1: '',
                    nameAr: '',
                    nameFr: '',
                    id: '',
                    idUser: '',
                    domainName: '',
                    idPage: ''
               }
               this.forUpdat = true
               this.idNews = 0
               this.news = {
                    id: '',
                    img: '',
                    title: '',
                    titleAr: '',
                    text1: '',
                    text1Ar: '',
                    text2: '',
                    text2Ar: '',
                    text3: '',
                    text3Ar: '',
                    text4: '',
                    text4Ar: '',
                    domainName: '',
               }
          },
          close() {
               this.dialog = false
          },
          saveImg() {
               this.isLoaded = true
               this.form.idUser = localStorage.getItem('HU88fd9DFDFJIJJDFD')
               this.form.domainName = document.location.origin
               let commit = 'getDataWebsite'
               let url = 'getDataWebsite/insertImg'

               this.$Register({
                    data: JSON.stringify(this.form),
                    file: this.form.P4S1Img1
               }, url, commit).then((e) => {
                    this.init()
                    this.isLoaded = false
                    this.dialog = false
                    this.$store.dispatch('getDataWebsite')
                    this.$store.dispatch('getGaleiItem')
                    this.data.form = this.website.filter(e => e.idPage = 4)
               }, () => {
                    this.isLoaded = false
               })

          },
          deleteImg(item) {
               var commit = 'getDataWebsite'
               var url = 'getDataWebsite/delete'

               this.$Delete({
                    data: JSON.stringify(item)
               }, url, commit).then((e) => {

                    this.$store.dispatch('getDataWebsite')
                    this.$store.dispatch('getGaleiItem')
                    this.data.form = this.website.filter(e => e.idPage = 4)
               })
          },
          sendData(id) {
               this.loader = 'loading4'
               this.data.idUser = localStorage.getItem('HU88fd9DFDFJIJJDFD')
               this.data.domainName = document.location.origin
               this.data.idPage = id
               let commit = 'getDataWebsite'
               let url = 'getDataWebsite/insertData'
               if (id == 1) {
                    this.$Register({
                         data: JSON.stringify(this.data),
                         file1: this.data.form[0].img,
                         file2: this.data.form[1].img,
                         file3: this.data.form[2].img,
                         file4: this.data.form[19].img,
                    }, url, commit)
               }
               if (id == 2) {
                    this.$Register({
                         data: JSON.stringify(this.data),
                         file5: this.data.form[28].img,
                         file6: this.data.form[40].img,
                         file7: this.data.form[47].img,
                         file8: this.data.form[54].img,
                         file9: this.data.form[78].img,
                    }, url, commit)
               }
               if (id == 3 || id == 6) {
                    this.$Register({
                         data: JSON.stringify(this.data)
                    }, url, commit)
               }
               if (id == 5) {
                    this.$Register({
                         data: JSON.stringify(this.data),
                         file10: this.data.form[90].img,
                         file11: this.data.form[93].img,
                         file12: this.data.form[96].img,
                         file13: this.data.form[99].img,
                    }, url, commit)
               }
          },
          /*************************************** */
          selectImgs() {
               this.hasImg = false
               this.P4S1Img1 = ''
               const file = event.target.files[0]
               this.form.P4S1Img1 = file
               this.P4S1Img1 = URL.createObjectURL(file)
          },
          selectImgNew() {
               this.forUpdat = false
               const file = event.target.files[0]
               this.news.img = file
               this.img = URL.createObjectURL(file)
          },
          selectImg(id, name) {
               this.data.form.find((ee, i) => {
                    console.log('i', i)
                    if (this.data.form[i].elementName == name) {
                         const file = event.target.files[0]
                         this.data.form[i].img = file
                         if (id == 1) {
                              this.items.P1S3Img1 = URL.createObjectURL(file)
                         } else if (id == 2) {
                              this.items.P1S1Img1 = URL.createObjectURL(file)
                         } else if (id == 3) {
                              this.items.P1S1Img2 = URL.createObjectURL(file)
                         } else if (id == 4) {
                              this.items.P1S1Img3 = URL.createObjectURL(file)
                         } else if (id == 5) {
                              this.items.P2S1Img1 = URL.createObjectURL(file)
                         } else if (id == 6) {
                              this.items.P2S1Img2 = URL.createObjectURL(file)
                         } else if (id == 7) {
                              this.items.P2S1Img3 = URL.createObjectURL(file)
                         } else if (id == 8) {
                              this.items.P2S1Img4 = URL.createObjectURL(file)
                         } else if (id == 9) {
                              this.items.P2S1Img5 = URL.createObjectURL(file)
                         } else if (id == 10) {
                              this.items.P5S1Img1 = URL.createObjectURL(file)
                         } else if (id == 11) {
                              this.items.P5S2Img1 = URL.createObjectURL(file)
                         } else if (id == 12) {
                              this.items.P5S3Img1 = URL.createObjectURL(file)
                         } else if (id == 13) {
                              this.items.P5S4Img1 = URL.createObjectURL(file)
                         }
                    }
               })
          },
          /********************************** */
          checkDefault2(item, state) {
               if (state) {
                    for (let i = 0; i < this.sections.length; i++) {
                         if (this.sections[i].id == item) {
                              return this.sections[i]
                         }
                    }
               } else {
                    for (let i = 0; i < this.myArray.length; i++) {
                         if (this.myArray[i].elementName == item) {
                              return this.myArray[i]
                         }
                    }
               }
          },
          getName(id) {
               return this.localLang == "fr" ? (this.checkDefault2(id, true) ? this.checkDefault2(id, true).nameFr : '') : (this.checkDefault2(id, true).nameAr ? this.checkDefault2(id, true).nameAr : '')
          },
          getNameFr(name) {
               return this.checkDefault2(name, false) ? this.checkDefault2(name, false).nameFr : ''
          },
          getNameAr(name) {
               return this.checkDefault2(name, false) ? this.checkDefault2(name, false).nameAr : ''
          },
          clear() {
               this.init()
          }
     },
     computed: {
          allNews() {
               return this.$store.state.news
          },
          scroll() {
               return Array.from({
                    length: this.length
               }, (k, v) => v + 1)
          },
          length() {
               return 7000
          },
          sections() {
               return this.$store.state.sections
          },

          myArray() {
               var arr = []
               let set = new Set();
               this.website.filter(e => {
                    if (!set.has(e.elementName)) {
                         arr.push(e)
                    }
                    set.add(e.elementName)
               })
               return arr
          }
     },
     created() {
          this.$store.dispatch('getDataWebsite')
          this.$store.dispatch('getGaleiItem')
          this.$store.dispatch('getNews')
          this.$store.dispatch('getMessage')
          this.$store.dispatch('getDemandes')
          this.init()
          Fire.$on('changeComponent', (child, idPage) => {
               this.$store.dispatch('getDataWebsite')
               this.data.form = {}
               this.child = child
               this.idPage = idPage
               this.data.form = this.website.filter(e => e.idPage == idPage)
               // if (this.idPage == 1) {
               //      this.data.form = this.myArray.filter(e => e.idPage == 1)
               // } else if (this.idPage == 2) {
               //      this.data.form = this.myArray.filter(e => e.idPage == 2)
               // } else if (this.idPage == 3) {
               //      this.data.form = this.myArray.filter(e => e.idPage == 3)
               // } else if (this.idPage == 4) {
               //      this.data.form = this.website.filter(e => e.idPage == 4)
               // } else if (this.idPage == 5) {
               //      this.data.form = this.myArray.filter(e => e.idPage == 5)
               // } else if (this.idPage == 6) {
               //      this.data.form = this.myArray.filter(e => e.idPage == 6)
               // }

          })
     }
}
</script>

<style>
.testHover:hover {
     background: testHover;
}

.v-btn:not(.v-btn--round).v-size--default {
     min-width: 36px !important;
     padding: 0 2px !important;
}

.v-card--reveal {
     align-items: center;
     bottom: 0;
     justify-content: center;
     opacity: .6;
     position: absolute;
     width: 100%;
     height: 100%
}
</style><style>
.v-content__wrap {
     max-width: 98.5%;
}

.custom-loader {
     animation: loader 1s infinite;
     display: flex;
}

@-moz-keyframes loader {
     from {
          transform: rotate(0);
     }

     to {
          transform: rotate(360deg);
     }
}

@-webkit-keyframes loader {
     from {
          transform: rotate(0);
     }

     to {
          transform: rotate(360deg);
     }
}

@-o-keyframes loader {
     from {
          transform: rotate(0);
     }

     to {
          transform: rotate(360deg);
     }
}

@keyframes loader {
     from {
          transform: rotate(0);
     }

     to {
          transform: rotate(360deg);
     }
}
</style>
